import Vue from "vue";
import App from "./App.vue";
import DofusPlugin from "./plugins/ladderFetch";

Vue.config.productionTip = false;

Vue.use(DofusPlugin);

new Vue({
  render: h => h(App)
}).$mount("#app");
